import * as React from 'react';
import {
  NotificationSettings,
  NotificationSettingsContext,
} from './NotificationSettings';

export interface WithNotificationsSettings extends NotificationSettings {}

export const withNotificationSettings = <P extends WithNotificationsSettings>(
  WrappedComponent: React.ComponentType<P>,
): React.ComponentType<Omit<P, keyof WithNotificationsSettings>> => props => {
  return (
    <NotificationSettingsContext.Consumer>
      {ctx => <WrappedComponent {...ctx} {...(props as P)} />}
    </NotificationSettingsContext.Consumer>
  );
};
